export default __webpack_public_path__ + "static/latitude-phone-scam-1cbf3e561e8edfb4e4842b3f658b69f1.webp";